import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
export default {
  name: 'XdfInput',
  components: {
    DarkBg: DarkBg
  },
  props: {
    btnText: {
      type: String,
      default: function _default() {
        return '激活';
      }
    }
  },
  data: function data() {
    return {
      colorOptions: {
        color0: 'rgba(230, 255, 243, 1)',
        // 左上
        color3: 'rgba(175, 255, 213, 1)' // 左下

      },
      codeList: [],
      activeIndex: 0,
      inputValue: '',
      // 小米浏览器用来缓存数据的，其他浏览器不用，直接从事件取值
      selectAll: false
    };
  },
  computed: {
    code: function code() {
      return this.codeList.map(function (item) {
        return item.value;
      }).join('');
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('paste', this.paste);
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      this.codeListInit();
      this.setCaret(0);
      document.addEventListener('paste', this.paste);
    },
    handleMobileInputFocus: function handleMobileInputFocus() {
      this.$refs.mobileInput && this.$refs.mobileInput.focus();
    },
    paste: function paste(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var clipText, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$nextTick();

              case 2:
                clipText = _this.replaceCode(event.clipboardData.getData('Text'));
                _this.codeList = _this.codeList.map(function (item, index) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    value: index >= _this.activeIndex && index < _this.activeIndex + clipText.length ? clipText.charAt(index - _this.activeIndex) : item.value
                  });
                });
                i = _this.activeIndex > 15 ? 15 : _this.activeIndex + clipText.length;

                _this.setCaret(i);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dealBackspace: function dealBackspace(event) {
      var _this2 = this;

      // 全选内容，删除所有
      if (this.selectAll) {
        this.codeList = this.codeList.map(function (item, index) {
          return {
            value: ''
          };
        });
        this.setCaret(0);
        return;
      } // 选取了，批量删除const indexArr =
      // this.getFromEndPosArr()
      // console.log(indexArr)
      // 单个删除


      this.codeList = this.codeList.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          value: index === _this2.activeIndex ? '' : item.value
        });
      });
      this.setCaret(this.activeIndex - 1);
    },
    dealNum: function dealNum(key) {
      var _this3 = this;

      var reg = /^[0-9]{1,}$/ig;

      if (reg.test(this.replaceCode(key))) {
        this.codeList = this.codeList.map(function (item, index) {
          return _objectSpread(_objectSpread({}, item), {}, {
            value: index === _this3.activeIndex ? key : item.value
          });
        });
        var i = this.activeIndex > 15 ? 15 : this.activeIndex + 1;
        this.setCaret(i);
      }
    },
    keyUp: function keyUp(event) {
      var key = event.key,
          keyCode = event.keyCode; // enter

      if (keyCode === 13) {
        this.confirm();
      } // shield F1-F12


      if (keyCode >= 112 && keyCode <= 123) {
        return;
      } // left


      if (keyCode === 37) {
        this.setCaret(this.activeIndex > 0 ? this.activeIndex - 1 : 0);
        return;
      } // right


      if (keyCode === 39) {
        this.setCaret(this.activeIndex > 15 ? 15 : this.activeIndex + 1);
        return;
      } // delete


      if (keyCode === 8) {
        this.dealBackspace();
        return;
      } // content should be just number


      if (keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105) {
        this.dealNum(key);
      } // 小米浏览器专用


      if (keyCode === 229) {
        this.dealNum(this.inputValue);
      }
    },
    inputChange: function inputChange(event) {
      this.inputValue = event.data;
    },
    mobileInputBlur: function mobileInputBlur() {
      this.handleMobileInputFocus();
    },
    getFromEndPosArr: function getFromEndPosArr() {
      this.getIndex();
    },
    getIndex: function getIndex(nodeName) {
      // [nodeName].parentNode
      var focusNode = document.getSelection().focusNode;
      var parentNode = focusNode.parentNode;
      console.log(focusNode.length, parentNode);
      var anchorNodeClassNames = parentNode.className.split(' ');
      var markItemIndex = anchorNodeClassNames.filter(function (item) {
        return item.indexOf('__split__') > -1;
      }).join('').split('__split__')[1];
      console.log(markItemIndex, focusNode.length);
      return markItemIndex;
    },
    codeListInit: function codeListInit() {
      this.codeList = new Array(16).fill('').map(function (item, index) {
        return {
          value: ''
        };
      });
    },
    selectstart: function selectstart(e) {
      console.log(e);
    },
    setCaret: function setCaret(i) {
      var _this4 = this;

      var activeIndex = i;

      if (i >= 15) {
        activeIndex = 15;
      }

      if (i <= 0) {
        activeIndex = 0;
      }

      this.activeIndex = activeIndex;
      this.selectAll = false;
      this.$nextTick(function () {
        _this4.handleMobileInputFocus();
      });
    },
    confirm: function confirm() {
      this.$emit('confirm', this.code);
    },
    replaceCode: function replaceCode(newVal) {
      return newVal.replace(/\D/g, '').slice(0, 16);
    }
  }
};